import React from "react";
import * as api from "../../shared/timeclock/services/api";
import { Balance } from "../models/balance";
import BalanceList from "../components/BalanceList";
import { connect } from "react-redux";
import { back } from "../actions";
import { Action, Dispatch } from "redux";

interface BalanceProps {
    personRef?: number;
    dispatch?: Dispatch<Action, unknown>;
}

interface BalanceState {
    balances?: Balance[];
}

function mapStateToProps(state) {
    return {
        personRef: state.session.stampPerson.personRef,
        dispatch: state.session.dispatch
    };
}

const connector = connect(mapStateToProps);

class _SaldoBalance extends React.Component<BalanceProps, BalanceState> {

    componentDidMount() {
        const person = this.props;
        api.balance(person.personRef)
            .then(balances => {
                this.setState({
                    balances
                });
            });
    }

    cancelClick = () => this.props.dispatch(back());
    render() {
        if (!this.state) {
            return false;
        }
        else
            return (
                <div className="balanceContainer">
                    <BalanceList balanceItems={this.state.balances} cancelClick={this.cancelClick} />
                </div>

            );
    }
}

export const SaldoBalance = connector(_SaldoBalance);
